import { createI18n } from '@aimsos/i18n';
import { uiI18nLoaders } from '@aimsos/ui/i18n/loaders.js';
import { registerChatI18n } from '@aimsos/chat/src/i18n/registerChatI18n.js';

/**
 * Single i18n instance for the Core Shell. Embeds reuse this via I18nextProvider.
 * Namespaces loaded at startup stay small; heavy module bundles load on route (see embeds).
 */
export const { i18n, registerNamespace } = createI18n({
  lng: 'es',
  fallbackLng: 'en',
  defaultNS: 'core-shell',
  initialNamespaces: ['core-shell', 'common', 'ui', 'chat'],
  registrations: {
    'core-shell': {
      en: () => import('../../locales/en.json'),
      es: () => import('../../locales/es.json'),
    },
    common: {
      en: () => import('../../locales/common/en.json'),
      es: () => import('../../locales/common/es.json'),
    },
    ui: uiI18nLoaders,
  },
});

registerChatI18n(registerNamespace);
